import React from 'react';
import { Spinner } from '@fluentui/react-components';

const Loader = ({ loading, text = "Loading..." }) => {
    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '12px',
        zIndex: 10,
    };

    const contentStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
    };

    const textStyle = {
        fontSize: '14px',
        color: '#4b5563',
    };

    return (
        loading ? (
            <div style={overlayStyle}>
                <div style={contentStyle}>
                    <Spinner size="medium" />
                    {text && <span style={textStyle}>{text}</span>}
                </div>
            </div>
        ) : null
    );
}

export default Loader;
